import Chip from '@material-ui/core/Chip';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import React from 'react';

const TemplateCardTags = ({ template }) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Grid, { item: true, xs: 12 }, /* @__PURE__ */ React.createElement(Divider, { "data-testid": "template-card-separator--tags" })), /* @__PURE__ */ React.createElement(Grid, { item: true, xs: 12 }, /* @__PURE__ */ React.createElement(Grid, { container: true, spacing: 2, "data-testid": "template-card-tags" }, template.metadata.tags?.map((tag) => /* @__PURE__ */ React.createElement(
  Grid,
  {
    key: `grid-${tag}`,
    item: true,
    "data-testid": `template-card-tag-item-${tag}`
  },
  /* @__PURE__ */ React.createElement(
    Chip,
    {
      style: { margin: 0 },
      size: "small",
      "data-testid": `template-card-tag-chip-${tag}`,
      label: tag,
      key: tag
    }
  )
)))));

export { TemplateCardTags };
//# sourceMappingURL=TemplateCardTags.esm.js.map
